import { request } from '@/common/utils/request'
const GET_SHOP_LIST_URL = 'crm.bdapp.shop.getList'
const GET_SHOP_DETAIL_URL = 'crm.bdapp.shop.getDetail'
const GET_SHOP_LIST_GETNAMESUG_URL = 'crm.bdapp.shop.getNameSug'
const GET_SHOP_OPEN_APPLY_URL = 'crm.bdapp.open.apply.get'
const UPDATE_SHOP_OPEN_APPLY_URL = 'crm.bdapp.open.apply.update'
const GET_SHOP_OPEN_PERMIT_URL = 'crm.bdapp.open.permit.getInfo'
const GET_SHOP_CATEGORY_ITEM_LIST_URL = 'crm.bdapp.shop.getItemListOfCategory'
const GET_SHOP_ALARM_LIST_URL = 'crm.bdapp.shop.getNotOnlineShopList'
const GET_FEATURE_GRAY_STATUS = 'feidian.common.getFeatureGrayStatus'

const commonData = {
  from_app: 1,
}

export function getShopList(params) {
  return request.get(GET_SHOP_LIST_URL, {
    params: {
      ...commonData,
      ...params,
    },
  })
}

export function getShopDetail({ shopId }) {
  return request.get(GET_SHOP_DETAIL_URL, {
    params: {
      ...commonData,
      shopId,
    },
  })
}

export function getFeatureGrayStatus(params) {
  return request.get(GET_FEATURE_GRAY_STATUS, {
    params: {
      ...commonData,
      ...params,
    },
  })
}

export function getShopOpenApplyDetail(params) {
  return request.post(GET_SHOP_OPEN_APPLY_URL, {
    data: { ...commonData, ...params },
  })
}

export function updateShopOpenApply(params) {
  return request.post(UPDATE_SHOP_OPEN_APPLY_URL, {
    data: { ...commonData, ...params },
  })
}

export function getShopOpenPermitInfo(params) {
  return request.post(GET_SHOP_OPEN_PERMIT_URL, {
    data: { ...commonData, ...params },
  })
}

export function getShopSugName(params) {
  return request.get(GET_SHOP_LIST_GETNAMESUG_URL, {
    params: { ...commonData, ...params },
  })
}

export function getShopCategoryItemList(params) {
  return request.get(GET_SHOP_CATEGORY_ITEM_LIST_URL, {
    params: {
      ...commonData,
      ...params,
    },
  })
}

export function getShopAlarmList(params) {
  return request.get(GET_SHOP_ALARM_LIST_URL, {
    params: {
      ...commonData,
      ...params,
    },
  })
}
